import detect from './rules/detect'
import detectCurly from './rules/detect-curly'
import detectDefault from './rules/detect-default'
import replaceDefault from './rules/default'
import exportFrom from './rules/from'
import { makeExports, addExportsRule } from './lib/add-exports'

/**
 * The initial rule to setup listeners for exports emitted during detection rules.
 */
const setupRule = {
  re: /[\s\S]*/,
  replacement(match) {
    this.exports = {}
    this.on('export', (e) => {
      this.exports = { ...this.exports, ...e }
    })
    return match
  },
}

/**
 * An À La Sequence to combine multiple rules from this package to detect and replace exports.
 */
const seq = [
  setupRule,
  detect,
  exportFrom,
  detectCurly,
  detectDefault,
  replaceDefault,
  addExportsRule,
]

export { makeExports }

export default seq